import React from "react";
import { Link } from "react-router-dom";
import { setUserClickData } from "../utility/setUserClickData";
import FooterSection from "./HomePageNew/components/footer/footer";

const ProtiumGrievance = () => {
  return (
    <div className="bg-black min-h-screen flex flex-col justify-between">
      <div className="container w-full h-full max-w-7xl mx-auto text-white px-3 sm:px-0 py-10">
        {/* Logo + Home */}
        <Link
          to={"/"}
          onClick={() => {
            setUserClickData({
              event_name: "link-to-home-page",
            });
          }}
        >
          <img
            className="pt-2"
            src="/assets/img/newLogo.png"
            alt="Digitmoney"
            width={160}
          />
        </Link>

        {/* Title Section */}
        <div className="pt-6">
          <h1 className="text-2xl md:text-3xl font-semibold text-green-400">
            Protium Finance Limited
          </h1>
          <h2 className="mt-2 text-sm md:text-md font-semibold text-blue-300">
            Grievance Redressal Mechanism
          </h2>
        </div>

        {/* Content Cards */}
        <div className="mt-10 grid sm:grid-cols-2 gap-2 sm:gap-4">

          {/* GRO Details */}
          <div className="bg-gray-900/30 p-6 rounded-xl shadow-lg border-[1px] text-sm sm:text-lg border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              1. Grievance Redressal Officer (GRO)
            </h3>
            <p className="text-gray-300 leading-relaxed">
              <span className="font-medium text-white">Name: </span>Mr. Anuj Chatterji
              <br />
              <span className="font-medium text-white">Designation: </span>Head Customer Service Department
              <br />
              <span className="font-medium text-white">Email: </span>
              <a
                href="mailto:GRO@protium.co.in"
                target="_blank"
                rel="noreferrer"
                className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors"
              >
                GRO@protium.co.in
              </a>
              <br />
              <span className="font-medium text-white">Contact Time: </span>Monday to Friday, 10:00 AM – 6:00 PM
              <br />
              <span className="font-medium text-white">Contact No: </span>+91 85912 01937
              <br />
              <span className="font-medium text-white">Address: </span>Protium Finance Limited, Nirlon Knowledge Park (NKP), B2, 7th Floor, Pahadi Village, Off Western Express Highway, Cama Industrial Estate, Goregaon (East), Mumbai 400063, Maharashtra
            </p>
          </div>

          {/* PNO Details */}
          <div className="bg-gray-900/30 p-6 rounded-xl shadow-lg border-[1px] text-sm sm:text-lg border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              2. Principal Nodal Officer (PNO)
            </h3>
            <p className="text-gray-400 text-sm mb-3 leading-relaxed">
              If the customers are not satisfied with the resolution provided on their grievance by GRO, they may escalate their dispute to the Principal Nodal Officer at the below address:
            </p>
            <p className="text-gray-300 leading-relaxed">
              <span className="font-medium text-white">Name: </span>Mr. Dhrumil Shah
              <br />
              <span className="font-medium text-white">Designation: </span>Principal Nodal Officer
              <br />
              <span className="font-medium text-white">Email: </span>
              <a
                href="mailto:principalnodalofficer@protium.co.in"
                target="_blank"
                rel="noreferrer"
                className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors"
              >
                principalnodalofficer@protium.co.in
              </a>
              <br />
              <span className="font-medium text-white">Contact Time: </span>Monday to Friday, 10:00 AM – 6:00 PM
              <br />
              <span className="font-medium text-white">Contact No: </span>+91 85919 84415
              <br />
              <span className="font-medium text-white">Address: </span>Protium Finance Limited, Nirlon Knowledge Park (NKP), B2, 7th Floor, Pahadi Village, Off Western Express Highway, Cama Industrial Estate, Goregaon (East), Mumbai 400063, Maharashtra
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <FooterSection />
    </div>
  );
};

export default ProtiumGrievance;
